import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#071020] text-slate-400 pt-14 pb-8">
      <div className="container mx-auto px-4">
        {/* メインコンテンツ */}
        <div className="grid md:grid-cols-3 gap-10 mb-12">
          {/* ブランド・会社情報 */}
          <div>
            <div className="mb-4">
              <span className="text-xl font-bold text-amber-400 tracking-wide">ProjectMaster</span>
              <p className="text-xs text-slate-500 mt-1">プロジェクトマスター</p>
            </div>
            <p className="text-sm leading-relaxed text-slate-400">
              DX・戦略コンサルティング領域に特化した<br />
              フリーランス向け案件紹介プラットフォーム。<br />
              単価160万円〜210万円クラスの<br />
              ハイエンド案件を厳選してご紹介します。
            </p>
          </div>

          {/* 会社概要 */}
          <div>
            <h3 className="text-white font-semibold text-sm mb-4 border-b border-slate-700 pb-2">
              運営会社概要
            </h3>
            <table className="w-full text-sm">
              <tbody className="space-y-2">
                <tr className="border-b border-slate-800">
                  <td className="py-2 pr-4 text-slate-500 whitespace-nowrap align-top">会社名</td>
                  <td className="py-2 text-slate-300">AtZBusinessPartners株式会社</td>
                </tr>
                <tr className="border-b border-slate-800">
                  <td className="py-2 pr-4 text-slate-500 whitespace-nowrap align-top">事業内容</td>
                  <td className="py-2 text-slate-300">DX・戦略コンサルティング支援、フリーランス案件紹介</td>
                </tr>
                <tr className="border-b border-slate-800">
                  <td className="py-2 pr-4 text-slate-500 whitespace-nowrap align-top">所在地</td>
                  <td className="py-2 text-slate-300">東京都渋谷区宇田川町1-12-1405</td>
                </tr>
                <tr>
                  <td className="py-2 pr-4 text-slate-500 whitespace-nowrap align-top">公式サイト</td>
                  <td className="py-2">
                    <a
                      href="https://atz-bp.co.jp/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-amber-400 hover:text-amber-300 transition-colors underline underline-offset-2"
                    >
                      atz-bp.co.jp
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* リンク */}
          <div>
            <h3 className="text-white font-semibold text-sm mb-4 border-b border-slate-700 pb-2">
              サービス案内
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#about" className="hover:text-amber-400 transition-colors cursor-pointer flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-amber-500"></i>
                  プロジェクトマスターとは
                </a>
              </li>
              <li>
                <a href="#benefits" className="hover:text-amber-400 transition-colors cursor-pointer flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-amber-500"></i>
                  選ばれる理由
                </a>
              </li>
              <li>
                <a href="#flow" className="hover:text-amber-400 transition-colors cursor-pointer flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-amber-500"></i>
                  ご利用の流れ
                </a>
              </li>
              <li>
                <a href="#faq" className="hover:text-amber-400 transition-colors cursor-pointer flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-amber-500"></i>
                  よくある質問
                </a>
              </li>
              <li>
                <a href="#registration" className="hover:text-amber-400 transition-colors cursor-pointer flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-amber-500"></i>
                  無料登録
                </a>
              </li>
            </ul>

            <h3 className="text-white font-semibold text-sm mt-6 mb-3 border-b border-slate-700 pb-2">
              お問い合わせ
            </h3>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-amber-500"></i>
                </div>
                <a
                  href="mailto:projectmaster@atz-bp.co.jp"
                  className="hover:text-amber-400 transition-colors"
                >
                  お問い合わせフォーム
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* 区切り線 */}
        <div className="border-t border-slate-800 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-slate-600">
            <p>&copy; {new Date().getFullYear()} AtZBusinessPartners株式会社 All Rights Reserved.</p>
            <div className="flex gap-4">
              <Link to="/privacy-policy" className="hover:text-slate-400 transition-colors cursor-pointer">プライバシーポリシー</Link>
              <Link to="/terms" className="hover:text-slate-400 transition-colors cursor-pointer">利用規約</Link>
              <span className="hover:text-slate-400 transition-colors cursor-pointer">特定商取引法に基づく表記</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}